import React from 'react';
import * as styles from './index.module.less';

interface IProps {
  isActive: boolean;
  handleClick?: () => void;
}

const NavMenuBtn = ({ isActive, handleClick }: IProps) => {
  return (
    <button className={styles.nav_menu_btn} onClick={handleClick}>
      <span className={`${styles.line} ${styles.line_a} ${isActive && styles.active}`}></span>
      <span className={`${styles.line} ${styles.line_b} ${isActive && styles.active}`}></span>
      <span className={`${styles.line} ${styles.line_c} ${isActive && styles.active}`}></span>
    </button>
  );
};
export default NavMenuBtn;
